import Card, { CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { usePageTitle } from '../../../hooks/shared';

export default function Settings() {
  usePageTitle('Settings');
  return (
    <div className="bg-neutral-50 min-h-screen py-8">
      <div className="container-custom max-w-4xl">
        <div className="mb-8">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-2">Account Settings</h1>
          <p className="text-neutral-600">Manage your profile, security, and preferences</p>
        </div>

        <div className="space-y-6">
          <Card patrioticShadow>
            <CardHeader>
              <CardTitle>Profile Information</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-neutral-600">
                Update your name, email, phone number, and other profile details.
              </p>
            </CardContent>
          </Card>

          <Card patrioticShadow>
            <CardHeader>
              <CardTitle>Addresses</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-neutral-600">
                Manage your residential and mailing addresses for accurate voter information.
              </p>
            </CardContent>
          </Card>

          <Card patrioticShadow>
            <CardHeader>
              <CardTitle>Security</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-neutral-600">
                Change your password, enable two-factor authentication, and manage security
                settings.
              </p>
            </CardContent>
          </Card>

          <Card patrioticShadow>
            <CardHeader>
              <CardTitle>Notification Preferences</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-neutral-600">
                Control how and when you receive election reminders and updates.
              </p>
            </CardContent>
          </Card>

          <Card patrioticShadow>
            <CardHeader>
              <CardTitle>Privacy & Data</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-neutral-600">
                Export your data, manage privacy settings, or delete your account.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
